require('angular').module('oly.common')
    .factory('geolocation', [require('./geolocation-factory')]);



// WEBPACK FOOTER //
// ./src/olycommon/geolocation/index.js